import React, { useId } from 'react';
import { UpcomingArcadeArtwork } from './UpcomingArcadeArtwork';
import { UpcomingTableArtwork } from './UpcomingTableArtwork';

const palettes = {
  plinko: ['#0fc4ba', '#076b99'], coinflip: ['#ffa23b', '#bd511d'],
  roulette: ['#ed4863', '#92213f'], baccarat: ['#6879ee', '#293e98'],
};

export const UpcomingGameArtwork = ({ game, preserveAspectRatio }) => {
  const id = useId().replace(/:/g, '');
  const [start, end] = palettes[game];
  return <svg viewBox="0 0 300 400" preserveAspectRatio={preserveAspectRatio} fill="none" className="originals-artwork" aria-hidden="true" focusable="false" data-testid={`upcoming-artwork-${game}-${id}`}>
    <defs>
      <linearGradient id={`${id}-bg`} x1="0" y1="0" x2="300" y2="400" gradientUnits="userSpaceOnUse"><stop stopColor={start} /><stop offset="1" stopColor={end} /></linearGradient>
      <linearGradient id={`${id}-shade`} x1="150" y1="210" x2="150" y2="400" gradientUnits="userSpaceOnUse"><stop stopColor="#101425" stopOpacity="0" /><stop offset="1" stopColor="#101425" stopOpacity=".65" /></linearGradient>
      <linearGradient id={`${id}-gold`} x1="-70" y1="-60" x2="65" y2="65" gradientUnits="userSpaceOnUse"><stop stopColor="#fff3b5" /><stop offset=".45" stopColor="#ffd16c" /><stop offset="1" stopColor="#df912c" /></linearGradient>
      <linearGradient id={`${id}-card`} x1="0" y1="0" x2="110" y2="140" gradientUnits="userSpaceOnUse"><stop stopColor="#fff" /><stop offset="1" stopColor="#dce8f4" /></linearGradient>
    </defs>
    <path d="M0 0h300v400H0z" fill={`url(#${id}-bg)`} />
    <path d="M0 100 300 15M0 205 300 120M0 310 300 225M60 0l92 400M190 0l92 400" stroke="#fff" strokeOpacity=".08" strokeWidth="3" />
    {['plinko', 'coinflip'].includes(game) ? <UpcomingArcadeArtwork game={game} id={id} /> : <UpcomingTableArtwork game={game} id={id} />}
    <path d="M0 210h300v190H0z" fill={`url(#${id}-shade)`} />
  </svg>;
};